import { baseEmailAssets, baseEmailTheme, TenantInfo } from '../common';
import { tos } from './tos';

export const tenant = {
  id: 'lmj',
  name: 'LMJ International Logistics',
  isSystemTenant: false,
  domains: [
    'lmj.localhost',
    'lmj.demo.pelicargo.dev',
    'lmj.tenant.pelicargo.dev',
    'lmjlogistics.com',
    /lmj\.staging-\d+\.pelicargo\.dev/,
  ],
  customerTheme: {
    colors: {
      primary: {
        '50': '#F3F9FA',
        '100': '#E1F2F5',
        '200': '#B9E4EC',
        '300': '#9BDBE6',
        '400': '#7EC0CC',
        '500': '#5E9CA5',
        '600': '#51868F',
        '700': '#3D676E',
        '800': '#2A494E',
        '900': '#182D31',
      },
      secondary: {
        '50': '#fbf7f3',
        '100': '#f8ece1',
        '200': '#f6d7b8',
        '300': '#f8c88e',
        '400': '#d89b29',
        '500': '#be8824',
        '600': '#a4751d',
        '700': '#7e5b14',
        '800': '#5b3f0b',
        '900': '#3a2705',
      },
    },
    logoDims: {
      height: 30,
      width: 130,
    },
    fullLogoDims: {
      height: '80px',
      width: '320px',
    },
  },
  emailTheme: {
    ...baseEmailTheme,
    primary: '#5E9CA5',
  },
  emailAssets: {
    ...baseEmailAssets,
    logo: 'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/lmj/logo.png',
    'logo-dark': 'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/lmj/lmj_logo_dark.svg',
    'logo-dark-tagline':
      'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/lmj/lmj_logo_dark_tagline.svg',
    'logo-light': 'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/lmj/lmj_logo_light.svg',
    'logo-light-tagline':
      'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/lmj/lmj_logo_light_tagline.svg',
    twitterUrl: 'https://to-be-determined/',
    facebookUrl: 'https://to-be-determined/',
    linkedinUrl: 'https://to-be-determined/',
    siteUrl: 'https://lmjlogistics.com',
  },
  admin: {
    cruds: {
      accounts: true,
      providers: false,
      airports: false,
      contacts: true,
      instructions: false,
      users: true,
      backlogs: false,
      'ai-inbox': false,
      surcharges: false,
      rates: false,
      'route-editor': false,
      configuration: false,
      'markup-configurations': true,
    },
    inbox: {
      requestDrawers: {
        // Provider Facing
        ProviderQuoting: false,
        AirlineBooking: false,
        RequestSchedule: false,
        BookingChange: false,
        BookingCancel: false,

        // Customer Facing
        QuoteUpdate: true,
        BookingConfirmation: true,
        NewRate: true,
        RequestClarifications: true,
        Contact: true,
        GenericEmailToFF: true,
        StatusUpdate: true,
      },
    },
    features: {
      instructionCreation: false,
    },
  },
  accountTypes: {
    IAC: false,
    IATA: false,
    ORGANIZATION: false,
    UNCERTIFIED: true,
  },
  customer: {
    requestFormDefaults: {
      freight_service: 'EXW',
      is_consolidated: true,
      extra_freight_services: [],
    },
    freightServices: {
      UNCERTIFIED: ['EXW', 'FCA'],
      default: ['EXW', 'FCA'],
    },
  },
  termsOfService: tos,
  helpUrl: 'https://docs.google.com/document/d/1CPAqKNH8qkimkl9ONXIB-8Lh-n9VbJTe9diBDWWqsW4/edit?usp=drive_link',
} as const satisfies TenantInfo<'lmj'>;
